import { Fragment, useMemo, useState } from "react";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import { StatusChip } from "../../Components/common/StatusChip";
import { PageHeader } from "../../Components/common/PageHeader";

export const WithdrawalList = () => {
  const { getData } = useDataFetch();

  const { data, isLoading } = getData(
    ["withdrawal"],
    "/withdrawal/all",
    {
      enabled: true,
    }
  );

  const columnHelper = createColumnHelper();

  const columns = useMemo(() => [
    columnHelper.accessor("name", { header: "Nombre" }),
    columnHelper.accessor("email", { header: "Correo" }),
    columnHelper.accessor("state", {
      header: "Estado",
      cell: info => {
        const state = info.getValue();
        return <StatusChip tone={state ? "success" : "neutral"}>{state ? "Activo" : "Inactivo"}</StatusChip>;
      }
    }),
    columnHelper.accessor("createdAt", {
      header: "Fecha",
      cell: info => {
        const rawDate = info.getValue();
        const date = new Date(rawDate);
        return date.toLocaleDateString();
      }
    }),
  ], [columnHelper]);

  const withdrawals = data?.data?.withdrawals ?? [];

  // `/withdrawal/all` no pagina en el backend: pagina en cliente sobre lo
  // ya cargado, sin duplicar el fetch.
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const pageData = withdrawals.slice(
    pagination.pageIndex * pagination.pageSize,
    (pagination.pageIndex + 1) * pagination.pageSize
  );

  return (
    <Fragment>
      <PageHeader title="Retiros" crumbs={[{ label: "Red" }, { label: "Retiros" }]} />

      <DataTable
        data={pageData}
        total={withdrawals.length}
        pagination={pagination}
        setPagination={setPagination}
        columns={columns}
        progressPending={isLoading}
        emptyMessage="No hay retiros para mostrar."
      />
    </Fragment>
  );
}
